export interface RegistrationCollectionsRequest {
  collections: {
    collectionNo: string
    holdingBranchCode: string
    buyDepartmentCode: string
    mark: string
    ndc: string
    book: string
    sub: string
    shelfType: string
    collectionType: string
    handlingType: string
    traderCode: string
    donorCode: string
    acceptDate: string
    acceptPrice: number
    acceptType: string
    appendixCode: string
    equipType: string
    budgetYear: number
    budgetBranchCode: string
    budgetDepartmentCode: string
    budgetExpenseCode: string
    _reserveAssign?: boolean
  }[]
}

export function RegistrationCollectionsRequestToJSON(
  value: RegistrationCollectionsRequest
): any {
  return {
    collections: value.collections.map(collection => {
      return {
        collection_no:
          collection.collectionNo !== '' ? collection.collectionNo : undefined,
        holding_branch_code:
          collection.holdingBranchCode !== ''
            ? collection.holdingBranchCode
            : undefined,
        buy_department_code:
          collection.buyDepartmentCode !== ''
            ? collection.buyDepartmentCode
            : undefined,
        mark: collection.mark !== '' ? collection.mark : undefined,
        ndc: collection.ndc !== '' ? collection.ndc : undefined,
        book: collection.book !== '' ? collection.book : undefined,
        sub: collection.sub !== '' ? collection.sub : undefined,
        shelf_type:
          collection.shelfType !== '' ? collection.shelfType : undefined,
        collection_type:
          collection.collectionType !== ''
            ? collection.collectionType
            : undefined,
        handling_type:
          collection.handlingType !== '' ? collection.handlingType : undefined,
        trader_code:
          collection.traderCode !== '' ? collection.traderCode : undefined,
        donor_code:
          collection.donorCode !== '' ? collection.donorCode : undefined,
        accept_date:
          collection.acceptDate !== '' ? collection.acceptDate : undefined,
        accept_price: collection.acceptPrice
          ? collection.acceptPrice
          : undefined,
        accept_type:
          collection.acceptType !== '' ? collection.acceptType : undefined,
        appendix_code:
          collection.appendixCode !== '' ? collection.appendixCode : undefined,
        equip_type:
          collection.equipType !== '' ? collection.equipType : undefined,
        budget_year: collection.budgetYear ? collection.budgetYear : undefined,
        budget_branch_code: collection.budgetBranchCode
          ? collection.budgetBranchCode
          : undefined,
        budget_department_code: collection.budgetDepartmentCode
          ? collection.budgetDepartmentCode
          : undefined,
        budget_expense_code: collection.budgetExpenseCode
          ? collection.budgetExpenseCode
          : undefined,
        _reserve_assign: collection._reserveAssign ?? undefined
      }
    })
  }
}
